import React, { useState, useEffect, useMemo, useContext } from "react";
import { Formik, Form } from "formik";
import { Button, TextField } from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import { workAPI } from "../../services/WorkService";
import { useDropzone } from "react-dropzone";
import { AppContext } from "./../../contexts/appContext";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Download from "downloadjs";
import * as Yup from "yup";
import { Clear } from "@material-ui/icons";

export const Create_Work_From = (props) => {
  let history = useHistory();
  const token = localStorage.getItem("Token");
  const { user, socket } = useContext(AppContext);
  const [type, setType] = useState([]);
  const [template, setTemplate] = useState([]);
  const [force, setForce] = useState(0);
  const [file, setFile] = useState([]);
  const formInitialValues = { title: "", comment: "" };
  const flatProps = {
    options: type.map((option) => option.type_name),
  };

  const findTypeLink = (parames) => {
    let typeFind = type.find((res) => res.type_name == parames);
    if (typeFind && typeFind.is_link) return true;
    else return false;
  };
  const FormSchema = Yup.object().shape({
    title: Yup.string().trim().required("*ใส่หัวเรื่องด้วย"),
    link: Yup.string().trim(),
  });
  useEffect(() => {
    workAPI
      .GetType(token, { use: "YES" })
      .then((res) => {
        if (res.status == 200) {
          if (Array.isArray(res.message)) {
            setType(res.message);
          }
          if (Array.isArray(res.message2)) {
            setTemplate(res.message2);
          }
        } else {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 10000,
          }).then(() => {
            // setForce((old) => old + 1)
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 10000,
        }).then(() => {
          // setForce((old) => old + 1)
        });
      });
  }, [force]);

  const SelectFile = ({ type }) => {
    return (
      <Autocomplete
        options={template
          .filter((res) => res.type == type)
          .map((option, index) => {
            return { id: index, name: option.template_file_show };
          })}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        getOptionLabel={(option) => option.name || ""}
        onChange={(event, newValue) => {
          let find_id = template
            .filter((res) => res.type == type)
            .find((res) => res.template_file_show == newValue.name);
          if (find_id) {
            workAPI
              .DownloadTemplateFile(token, find_id._id)
              .then((response) => {
                if (response.status == 200) {
                  Download(
                    response.data,
                    newValue.name,
                    response.headers["content-type"]
                  );
                } else {
                  Swal.fire({
                    icon: "error",
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${response.message}</span>`,
                    backdrop: "transparent",
                    background: "rgba(0,0,0,.75)",
                    customClass: {
                      icon: "switch",
                    },
                    width: "28rem",
                    timer: 3000,
                  });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  confirmButtonColor: "#f27474",
                  html: `<span class="colorWhite">${error.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switch",
                  },
                  width: "28rem",
                  timer: 3000,
                });
              });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Download file template..."
            variant="standard"
          />
        )}
      />
    );
  };

  const DeleteFileByIndex = (index) => {
    let fileZ = file.filter((res, i) => i != index);
    setFile(fileZ);
  };

  const DropZoneComponents = (props) => {
    const activeStyle = {
      borderColor: "#2196f3",
    };

    const acceptStyle = {
      borderColor: "#00e676",
    };

    const rejectStyle = {
      borderColor: "#ff1744",
    };

    const {
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject,
    } = useDropzone({
      maxFiles: 20,
      // accept: 'image/jpeg, image/png',
      onDrop: (acceptedFiles) => {
        setFile((old) => [...old, ...acceptedFiles]);
      },
    });
    const style = useMemo(
      () => ({
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
      }),
      [isDragActive, isDragReject, isDragAccept]
    );

    const acceptedFileItems = file
      .filter((res, i) => i <= 19)
      .map((file, i) => (
        <li key={i}>
          {file.path} - {file.size} bytes{" "}
          <Clear
            style={{ color: "red", fontSize: 16, cursor: "pointer" }}
            onClick={() => DeleteFileByIndex(i)}
          />
        </li>
      ));

    const fileRejectionItems = file
      .filter((res, i) => i > 19)
      .map((file, i) => {
        return (
          <li key={i}>
            {file.path} - {file.size} bytes{" "}
            <Clear
              style={{ color: "red", fontSize: 16, cursor: "pointer" }}
              onClick={() => DeleteFileByIndex(i)}
            />
            <ul>
              <li>ไฟล์ที่เกิน</li>
            </ul>
          </li>
        );
      });

    return (
      <>
        <section
          className="container uploadBox"
          {...getRootProps({ style, onClick: (evt) => evt.preventDefault() })}
        >
          <div
            {...getRootProps({
              className: "dropzone",
              onClick: (evt) => evt.preventDefault(),
            })}
          >
            <input {...getInputProps()} />
            <p>เลือกไฟล์หรือลากไฟล์เพื่ออัพโหลดไฟล์ (สูงสุด 20 ไฟล์)</p>
          </div>
        </section>
        <aside>
          {acceptedFileItems.length >= 1 && (
            <div>
              <h5>
                Accepted files{" "}
                <Clear
                  style={{ color: "red", fontSize: 18, cursor: "pointer" }}
                  onClick={() => setFile([])}
                />
              </h5>
              <ul>{acceptedFileItems}</ul>
            </div>
          )}
          {fileRejectionItems.length >= 1 && (
            <div>
              <h5>Rejected files</h5>
              <ul>{fileRejectionItems}</ul>
            </div>
          )}
        </aside>
      </>
    );
  };

  return (
    <Formik
      validationSchema={FormSchema}
      initialValues={{ ...formInitialValues }}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        try {
          Swal.fire({
            title: "คุณแน่ใจ ?",
            text: `ต้องการเพิ่มงาน ${values.title}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#56A834",
            cancelButtonColor: "#d33",
            confirmButtonText: "แน่ใจ",
            cancelButtonText: "ยังก่อน",
          }).then((result) => {
            try {
              if (result.isConfirmed) {
                setSubmitting(true);
                if (!values.type) throw { message: "เลือก Type ด้วยครับ" };
                let form = new FormData();
                form.append("title", values.title);
                form.append("comment", values.comment || values.title);
                form.append("type", values.type);
                if (findTypeLink(values.type)) {
                  form.append("link", values.link || null);
                }
                if (file && Array.isArray(file) && file.length >= 1) {
                  file
                    .filter((res, i) => i <= 19)
                    .map((res, i) => {
                      form.append(`file_fisrt${i}`, res);
                    });
                }
                workAPI
                  .AddWork(token, form)
                  .then((res) => {
                    if (res.status == 200) {
                      socket.emit("UpdateWork", { _id: res._id });
                      setSubmitting(false);
                      Swal.fire({
                        icon: "success",
                        confirmButtonColor: "#6ab23a",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: "transparent",
                        background: "rgba(0,0,0,.75)",
                        customClass: {
                          icon: "switchZ",
                        },
                        width: "28rem",
                        timer: 3000,
                      }).then(() => {
                        history.push("/");
                      });
                    } else {
                      Swal.fire({
                        icon: "error",
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: "transparent",
                        background: "rgba(0,0,0,.75)",
                        customClass: {
                          icon: "switch",
                        },
                        width: "28rem",
                        timer: 10000,
                      });
                    }
                    setSubmitting(false);
                  })
                  .catch((error) => {
                    setSubmitting(false);
                    Swal.fire({
                      icon: "error",
                      confirmButtonColor: "#f27474",
                      html: `<span class="colorWhite">${error.message}</span>`,
                      backdrop: "transparent",
                      background: "rgba(0,0,0,.75)",
                      customClass: {
                        icon: "switch",
                      },
                      width: "28rem",
                      timer: 10000,
                    });
                  });
              }
            } catch (error) {
              setSubmitting(false);
              Swal.fire({
                icon: "error",
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                backdrop: "transparent",
                background: "rgba(0,0,0,.75)",
                customClass: {
                  icon: "switch",
                },
                width: "28rem",
                timer: 3000,
              });
            }
          });
        } catch (error) {
          setSubmitting(false);
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          });
        }
      }}
    >
      {({
        values,
        handleChange,
        setFieldValue,
        isSubmitting,
        touched,
        errors,
      }) => (
        <Form style={{ display: !user ? "none" : "block" }}>
          <div className="form-outline mb-4">
            <Autocomplete
              {...flatProps}
              value={values.type || null}
              onChange={(event, newValue) => {
                setFieldValue("type", newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Type..." variant="standard" />
              )}
            />
          </div>
          <div className="form-outline mb-4">
            <TextField
              fullWidth
              label="Title..."
              name="title"
              value={values.title || ""}
              onChange={handleChange}
            />
            {errors.title && touched.title ? (
              <div style={{ color: "#FF3333" }}>{errors.title}</div>
            ) : null}
          </div>
          {values.type && findTypeLink(values.type) && (
            <div className="form-outline mb-4">
              <TextField
                fullWidth
                label="Google Drive link..."
                name="link"
                value={values.link || ""}
                onChange={handleChange}
              />
              {errors.link && touched.link ? (
                <div style={{ color: "#FF3333" }}>{errors.link}</div>
              ) : null}
            </div>
          )}
          {values.type && (
            <div className="form-outline mb-4">
              <SelectFile type={values.type} />
            </div>
          )}
          <div className="form-outline mb-4">
            <TextField
              name="comment"
              value={values.comment || ""}
              onChange={handleChange}
              label="Comment..."
              multiline
              variant="outlined"
              style={{ width: "100%", minWidth: "100%" }}
            />
            {errors.comment && touched.comment ? (
              <div style={{ color: "#FF3333" }}>{errors.comment}</div>
            ) : null}
          </div>
          <div
            className="form-outline mb-4"
            style={{ margin: "auto", width: "80%", marginTop: "5%" }}
          >
            <DropZoneComponents setFieldValue={setFieldValue} />
          </div>
          <Button
            type="submit"
            variant="contained"
            style={{
              margin: "2%",
              backgroundColor: "rgb(91, 184, 70)",
              color: "whitesmoke",
            }}
            size="small"
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  );
};
